export default __webpack_public_path__ + "static/media/sketch.c9f5475f.svg";